import styled from 'styled-components';

const GetModuleButtonWrapper = styled.div``;

export { GetModuleButtonWrapper };
